import { useState } from "react";
import StarField from "@/components/StarField";
import TopBar from "@/components/TopBar";
import api from "@/lib/api";
import { toast } from "sonner";

export default function InfluencerApply() {
  const [form, setForm] = useState({ full_name: "", email: "", instagram_handle: "", followers: 0, pitch: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/influencer/apply", { ...form, followers: parseInt(form.followers) || 0 });
      setSubmitted(true);
      toast.success("Application received. We watch. We decide.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  if (submitted) {
    return (
      <div className="relative min-h-screen">
        <StarField count={150} />
        <TopBar />
        <main className="relative z-20 flex items-center justify-center px-6 py-24">
          <div className="glass-strong rounded-sm p-12 max-w-lg text-center" data-testid="influencer-apply-success">
            <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-fuchsia-400 mb-2">— observed —</div>
            <h1 className="font-display text-3xl font-black uppercase neon-magenta">Application Logged</h1>
            <p className="font-mono text-sm text-white/70 mt-6">You'll receive credentials if selected. The eye sees everything.</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen">
      <StarField count={140} />
      <TopBar />
      <main className="relative z-20 flex items-center justify-center px-6 py-16">
        <div className="glass-strong rounded-sm p-10 w-full max-w-lg">
          <div className="text-center">
            <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-fuchsia-400 mb-2">— petition —</div>
            <h1 className="font-display text-3xl font-black uppercase neon-magenta">Influencer Application</h1>
          </div>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input required value={form.full_name} onChange={set("full_name")} placeholder="Full name" data-testid="influencer-apply-name" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-fuchsia-400/80" />
            <input type="email" required value={form.email} onChange={set("email")} placeholder="Email" data-testid="influencer-apply-email" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-fuchsia-400/80" />
            <input required value={form.instagram_handle} onChange={set("instagram_handle")} placeholder="@instagram" data-testid="influencer-apply-ig" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-fuchsia-400/80" />
            <input type="number" required value={form.followers} onChange={set("followers")} placeholder="Followers" data-testid="influencer-apply-followers" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-fuchsia-400/80" />
            <textarea required value={form.pitch} onChange={set("pitch")} placeholder="Why you?" rows={4} data-testid="influencer-apply-pitch" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-fuchsia-400/80" />
            <button type="submit" disabled={loading} data-testid="influencer-apply-submit" className="gate w-full py-3 bg-fuchsia-500 text-black font-display font-bold uppercase tracking-[0.3em] text-xs rounded-sm hover:scale-[1.02] transition">
              {loading ? "..." : "Submit Petition"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
